import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../../services/apiAxios';
import helpers from '../../../mixins/helpers';
import moment from 'moment';

const state = {
    indicadorRentabilidad: {},
    /* Total -> incluye reembolsos */
    indicadorRentabilidadTotal: {},

    indicadoresRentabilidadHistorico: [],

    resultadosIndicadorRentabilidad: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_INDICADORES' (state) {
        state.indicadorRentabilidad = {};
    },
    'INICIALIZAR_INDICADORES_TOTAL' (state) {
        state.indicadorRentabilidadTotal = {};
    },
    'INICIALIZAR_INDICADORES_HISTORICO' (state) {
        state.indicadoresRentabilidadHistorico = [];
    },

    'SET_INDICADOR_RENTABILIDAD'(state, indicador) {
        state.indicadorRentabilidad = indicador;
    },
    'SET_INDICADOR_RENTABILIDAD_TOTAL'(state, indicador) {
        state.indicadorRentabilidadTotal = indicador;
    },
    'SET_INDICADORES_RENTABILIDAD_HISTORICO'(state, indicadores) {
        // console.log(indicadores);
        state.indicadoresRentabilidadHistorico = indicadores;
    },


    'INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD'(state) {
        state.resultadosIndicadorRentabilidad = [];
    },
    'SET_RESULTADOS_INDICADOR_RENTABILIDAD'(state, resultadosIndicadorRentabilidad) {
        state.resultadosIndicadorRentabilidad = resultadosIndicadorRentabilidad;
    },
};

const getters = {
    getField,

    indicadorRentabilidad(state) {
        return state.indicadorRentabilidad;
    },
    indicadorRentabilidadTotal(state) {
        return state.indicadorRentabilidadTotal;
    },
    indicadoresRentabilidadHistorico(state) {
        return state.indicadoresRentabilidadHistorico;
    },
    resultadosIndicadorRentabilidad(state) {
        return state.resultadosIndicadorRentabilidad;
    },

};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES');
            resolve();
        })
    },
    getIndicadorRentabilidad ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/rentabilidad')
                .then(res => {
                    commit('SET_INDICADOR_RENTABILIDAD', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    inicializarTotal ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES_TOTAL');
            resolve();
        })
    },
    getIndicadorRentabilidadTotal ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/rentabilidad/total')
                .then(res => {
                    commit('SET_INDICADOR_RENTABILIDAD_TOTAL', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    inicializarHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES_HISTORICO');
            resolve();
        })
    },
    getIndicadoresRentabilidadHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/rentabilidad/historico')
                .then(res => {
                    commit('SET_INDICADORES_RENTABILIDAD_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getIndicadoresRentabilidadSemestralHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES_HISTORICO');

            apiAxios.get('indicadores/rentabilidad-bruta/semestral/historico')
                .then(res => {
                    commit('SET_INDICADORES_RENTABILIDAD_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresRentabilidadSemestralTotalHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES_HISTORICO');

            apiAxios.get('indicadores/rentabilidad-bruta/semestral/historico/total')
                .then(res => {
                    commit('SET_INDICADORES_RENTABILIDAD_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresRentabilidadAnualHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES_HISTORICO');

            apiAxios.get('indicadores/rentabilidad-bruta/anual/historico')
                .then(res => {
                    commit('SET_INDICADORES_RENTABILIDAD_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresRentabilidadAnualTotalHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES_HISTORICO');

            apiAxios.get('indicadores/rentabilidad-bruta/anual/historico/total')
                .then(res => {
                    commit('SET_INDICADORES_RENTABILIDAD_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    

    getPresupuestosIndicadorRentabilidad ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD');

            apiAxios.get('indicadores/rentabilidad/presupuestos')
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getPresupuestosIndicadorRentabilidadTotal ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD');

            apiAxios.get('indicadores/rentabilidad/total/presupuestos')
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getPresupuestosIndicadorRentabilidadHistorico ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');
            
            let url = 'indicadores/rentabilidad/historico/presupuestos' + query;
            if (params.totalNegocio) {
                url = 'indicadores/rentabilidad/total/historico/presupuestos' + query;
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    actualizarResultadosIndicadorRentabilidad ( {} ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('indicadores/rentabilidad/actualizar')
                .then(res => {
                    if (res.status == 200) {
                        resolve();
                    } else {
                        reject('No se pudo actualizar la información del indicador')
                    }
                })
                .catch(() => reject('No se pudo actualizar la información del indicador'));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}